import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getAnnouncement } from '../../services'
import { GetAnnouncementResponse } from '@/modules/announcement/type'
import { GetAnnouncementRequest } from '@/modules/announcement/type'
import { AnnouncementQueryKeys } from '@/modules/announcement/keys'

export default function useQueryGetAnnouncement(
	payload: GetAnnouncementRequest,
	props?: UseBaseQueryOptions<GetAnnouncementResponse>,
) {
	return useQuery({
		queryKey: [AnnouncementQueryKeys.getAnnouncement, payload],
		queryFn: () => getAnnouncement(payload),
		...props,
	})
}
